import { createFileRoute, redirect } from "@tanstack/react-router";

import { CommandPalette } from "@/components/command-palette";
import { HotkeyCheatsheet } from "@/components/hotkey-cheatsheet";
import { NotFound } from "@/components/not-found";
import { AppShell } from "@/components/shell/layout";
import { WebSocketProvider } from "@/ws/provider";
import { useAuth } from "@/stores/auth";

function AuthedLayout() {
  return (
    <WebSocketProvider enabled={true}>
      <AppShell />
      <CommandPalette />
      <HotkeyCheatsheet />
    </WebSocketProvider>
  );
}

/**
 * Protected layout. `beforeLoad` hits `/api/auth/me` via the Zustand store
 * so it uses the same fetch path as the rest of the app. If the user is
 * unauthenticated, redirect to /login. The root layout already kicks off
 * an initial `fetchMe`; here we await it to avoid a flash.
 */
export const Route = createFileRoute("/_auth")({
  beforeLoad: async () => {
    const store = useAuth.getState();
    if (store.status === "authenticated") return;
    const user = await store.fetchMe();
    if (!user) {
      throw redirect({ to: "/login" });
    }
  },
  component: AuthedLayout,
  notFoundComponent: NotFound,
});
